export const BASE_API_URL = "https://alsoft.manejoagranel.com/v1";
